import React from 'react';

import './styles.css';

interface TooltipProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ title, ...rest }) => (
  <div className='mh-tooltip' {...rest}>
    <span>{title}</span>
  </div>
);

export default Tooltip;
